module.exports = __webpack_public_path__ + "static/img/banner.684e26e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/module/index/images/banner.jpg
// module id = WTTM
// module chunks = 3